export default {
  SET_IS_SHOW_MENU(state, data){
    state.isShowMenu = data;
  },
  SET_IS_DISPLAY_OTHER_VESSELS(state, data){
    state.isDisplayOtherVessels = data;
  },
  SET_ON_ALERT_SUMMARY_NOTIFICATION(state, data){
    state.onAlertSummaryNotification = data;
  },
  SET_ON_VESSEL_AUTO_TRACKING(state, data) {
    state.onVesselAutoTracking = data;
  },
  SET_TRACK_DISPLAY_INTERVAL(state, data) {
    state.trackDisplayInterval = data;
  },
  SET_TRACK_HISTORY_INTERVAL(state, data) {
    state.trackHistoryInterval = data;
  },
  SET_SHOW_DIALOG_SELECT_VESSEL(state, data){
    state.showDialogSelectVessel = data;
  },
  RESET_STATE(state, data) {
    Object.assign(state, data);
  },
  SET_SETTINGS(state, data) {
    Object.assign(state, data);
  },
};
